import { Typography } from "@mui/material";
import { WorkflowRefMethod } from "~/operations";
import { pluralize } from "~/lib/pluralize";
import { WorkflowScopeData } from "./WorkflowScopeTable";

interface WorkflowScopeTableTitleProps {
  scopeData: WorkflowScopeData;
}

export default function WorkflowScopeTableTitle({
  scopeData,
}: WorkflowScopeTableTitleProps) {
  const { listItems = [] } = scopeData;
  const items = listItems || [];

  const selectedCount =
    items.filter((k) => k.method === WorkflowRefMethod.Selected).length || 0;

  // Math.max so that we don't show negative related findings
  const relatedCount = Math.max(0, items.length - selectedCount);

  return (
    <Typography variant="h4">
      Scope{" "}
      <Typography variant="h4" component="span" sx={{ fontWeight: "normal" }}>
        {selectedCount} selected {pluralize("finding", selectedCount)},{" "}
        {relatedCount} related
      </Typography>
    </Typography>
  );
}
